import { supabase } from "@/integrations/supabase/client";

export async function getAppSetting(key: string): Promise<string | null> {
  const { data, error } = await (supabase as any)
    .from("app_settings")
    .select("value")
    .eq("key", key)
    .maybeSingle();

  if (error) throw new Error(`Failed to fetch app setting: ${error.message}`);

  return data?.value ?? null;
}

export async function updateAppSetting(key: string, value: string): Promise<void> {
  const { error } = await (supabase as any).from("app_settings").upsert(
    { key, value, updated_at: new Date().toISOString() },
    {
      onConflict: "key",
    },
  );

  if (error) throw new Error(`Failed to update app setting: ${error.message}`);
}
